// extracted by mini-css-extract-plugin
export default {"wrapper":"TE-z","viewport":"UE-z","container":"VE-z","slide":"WE-z"};